export default __webpack_public_path__ + "static/media/crown.9a28fda6.png";